// src/icons/index.ts
import {
  ArrowLeftIcon,
  ArrowRightIcon,
  Bars3Icon,
  ChevronDownIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  EllipsisHorizontalIcon,
  MagnifyingGlassIcon,
  PencilSquareIcon,
  PlusIcon,
  TrashIcon,
  UserCircleIcon,
  XMarkIcon
} from "@heroicons/react/24/outline";
import {
  CheckIcon,
  CheckCircleIcon,
  ExclamationCircleIcon,
  ExclamationTriangleIcon,
  InformationCircleIcon,
  XCircleIcon
} from "@heroicons/react/24/solid";
var iconSizeClassNames = {
  compact: "paper-icon-compact",
  default: "paper-icon-default",
  prominent: "paper-icon-prominent",
  emptyState: "paper-icon-empty-state"
};
function iconClassName(size = "default", className) {
  return [iconSizeClassNames[size], className].filter(Boolean).join(" ");
}
export {
  ArrowLeftIcon,
  ArrowRightIcon,
  Bars3Icon,
  CheckCircleIcon,
  CheckIcon,
  ChevronDownIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  EllipsisHorizontalIcon,
  ExclamationCircleIcon,
  ExclamationTriangleIcon,
  InformationCircleIcon,
  MagnifyingGlassIcon,
  PencilSquareIcon,
  PlusIcon,
  TrashIcon,
  UserCircleIcon,
  XCircleIcon,
  XMarkIcon,
  iconClassName,
  iconSizeClassNames
};
//# sourceMappingURL=icons.js.map